/* eslint-disable no-unused-vars */
import { Button, Col, Form, Row, Typography, Popconfirm, Input } from "antd";
import React, { forwardRef } from "react";
import { FaTrash } from "react-icons/fa";
import UploadPreview from "./UploadPreview";

const FormBanner = ({ form, handleDelete }, ref) => {
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.file;
  };

  const { getFieldDecorator, getFieldsValue } = form;

  return (
    <Form colon={false}>
      <Row gutter={{ xs: 16, md: 32 }}>
        <Col md={24}>
          <Row type="flex" justify="space-between" className="mt-3 mb-1">
            <Col span={24} xl={12}>
              <Form.Item style={{ margin: 0 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      whiteSpace: "nowrap",
                      marginRight: 8,
                      marginBottom: 0,
                    }}
                  >
                    ลิงก์สำหรับ Web:
                  </label>
                  {getFieldDecorator("web_link", {
                    initialValue: "",
                    rules: [{ required: false }],
                  })(
                    <Input
                      placeholder="วาง Url ที่นี่"
                      style={{ width: "100%" }}
                    />
                  )}
                </div>
              </Form.Item>
            </Col>
            <Col xl={12} />
            <Col span={24} xl={12}>
              <Form.Item style={{ margin: 0 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      whiteSpace: "nowrap",
                      marginRight: 8,
                      marginBottom: 0,
                    }}
                  >
                    ลิงก์สำหรับ App:
                  </label>
                  {getFieldDecorator("app_link", {
                    initialValue: "",
                    rules: [{ required: false }],
                  })(
                    <Input
                      placeholder="วาง Url ที่นี่"
                      style={{ width: "100%" }}
                    />
                  )}
                </div>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Typography.Text>Website: 2750 x 738 px</Typography.Text>
            </Col>
            {/* {getFieldsValue().online_banner && (
              <Col span={8} align="right">
                <Popconfirm
                  title="ต้องการลบรูปหรือไม่"
                  okText="ยืนยัน"
                  cancelText="ยกเลิก"
                  onConfirm={() => handleDelete("web")}
                >
                  <Button type="danger" ghost>
                    <FaTrash />
                  </Button>
                </Popconfirm>
              </Col>
          )} */}
          </Row>
          <Form.Item>
            {getFieldDecorator("online_banner", {
              valuePropName: "file",
              getValueFromEvent: normFile,
            })(<UploadPreview fix_width={2750} fix_height={738} />)}
          </Form.Item>
          <Row type="flex" justify="space-between" className="mt-3 mb-1">
            <Col span={8}>
              <Typography.Text>Mobile: 1200 x 401 px</Typography.Text>
            </Col>
            {/* {getFieldsValue().mobile_banner && (
              <Col span={8} align="right">
                <Popconfirm
                  title="ต้องการลบรูปหรือไม่"
                  okText="ยืนยัน"
                  cancelText="ยกเลิก"
                  onConfirm={() => handleDelete("mobile")}
                >
                  <Button type="danger" ghost>
                    <FaTrash />
                  </Button>
                </Popconfirm>
              </Col>
          )} */}
          </Row>
          <Form.Item>
            {getFieldDecorator("mobile_banner", {
              valuePropName: "file",
              getValueFromEvent: normFile,
            })(<UploadPreview fix_width={1200} fix_height={401} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default Form.create("banner")(forwardRef(FormBanner));
